let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2h1uc")).then(() => parcelRequire('7AMRE'));